import { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AppContext, AjaxContext, formatListData, UserContext } from 'commons-ui';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { UserDetailsContext } from 'context/userDetails';
import { AnalyzeCollusionProps } from '../types';

const useService = ({ ltid, tournamentStartTime, gameName, tableId }: AnalyzeCollusionProps) => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const [analyzeCollusionIsCollapsed, setAnalyzeCollusionIsCollapsed] = useState<boolean>(true);
	const [analyzeCollusionData, setAnalyzeCollusionData] = useState<any>();
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);

	const copyToClipboard = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		navigator.clipboard.writeText(JSON.stringify(_get(analyzeCollusionData, 'data', []), null, 2));
	};

	const handleDatalistFetchData = () => {
		return analyzeCollusionData;
	};

	const fetchAnalyzeCollusionData = async () => {
		const permission = _find(permissionsConfig, { actionName: ACTION.analyzeCollusion });
		const result = await postData({
			endpoint: `/dashboard/analyzeCollusion/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-analyzeCollusion`,
			queryParams: {
				appName
			},
			body: {
				zupeeUserId: uid,
				ltid: Number(ltid),
				date: tournamentStartTime.split(' ')[0].split('-').reverse().join('-'),
				gameName,
				tableId,
				label: 'collusion_ludo_supreme'
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		return _get(result, ['data', 'data'], []);
	};

	useEffect(() => {
		const fetchRowData = async () => {
			try {
				setShowLoader(true);
				const fetchedData = await fetchAnalyzeCollusionData();
				setAnalyzeCollusionData({ rowCount: fetchedData.length, data: formatListData(fetchedData) });
			} catch (error: any) {
				showAlert(_get(error, 'error', 'Error while fetching data'), { type: 'error' });
			} finally {
				setShowLoader(false);
				setDataFetchComplete(true);
			}
		};

		if (!analyzeCollusionIsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [analyzeCollusionIsCollapsed, dataFetchComplete]);

	return {
		analyzeCollusionIsCollapsed,
		setAnalyzeCollusionIsCollapsed,
		dataFetchComplete,
		showLoader,
		copyToClipboard,
		handleDatalistFetchData
	};
};

export default useService;
